<template>
  <div>
    <table class="ui small definition table">
      <tbody>
        <tr>
          <td>Type</td>
          <td v-if="checklist.check_in">
            <strong>Check In</strong>
          </td>
          <td v-if="checklist.check_out">
            <strong>Check Out</strong>
          </td>
        </tr>
        <tr>
          <td>Yacht</td>
          <td v-if="checklist.check_in">
            {{ checklist.yacht.name }}
            <div
              v-if="checklist.check_in.yacht_engine_hours"
              class="mb-1"
            >
              Hours:
              <strong
                v-for="(yachtEngineHours, i) in checklist.check_in.yacht_engine_hours"
                :key="i"
                class="ui label mr-1"
              >
                {{ yachtEngineHours.hours }} h
              </strong>
            </div>
            <div
              v-if="checklist.check_in.yacht_fuel_tank_levels"
              class="mb-1"
            >
              Fuel:
              <strong
                v-for="(fuelTankLevel, i) in checklist.check_in.yacht_fuel_tank_levels"
                :key="i"
                class="ui label mr-1"
              >
                {{ fuelTankLevel }} l
              </strong>
            </div>
            <div
              v-if="checklist.check_in.yacht_generator_hours"
              class="mb-1"
            >
              Generator Hours:
              <strong
                class="ui label mr-1"
              >
                {{ checklist.check_in.yacht_generator_hours }} h
              </strong>
            </div>
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.yacht.name }}
            <div
              v-if="checklist.check_out.yacht_engine_hours"
              class="mb-1"
            >
              Engine Hours:
              <strong
                v-for="(yachtEngineHours, i) in checklist.check_out.yacht_engine_hours"
                :key="i"
                class="ui label mr-1"
              >
                {{ yachtEngineHours.hours }} h
              </strong>
            </div>
            <div
              v-if="checklist.check_out.yacht_fuel_tank_levels"
              class="mb-1"
            >
              Fuel:
              <strong
                v-for="(fuelTankLevel, i) in checklist.check_out.yacht_fuel_tank_levels"
                :key="i"
                class="ui label mr-1"
              >
                {{ fuelTankLevel }} l
              </strong>
            </div>
            <div
              v-if="checklist.check_out.yacht_generator_hours"
              class="mb-1"
            >
              Generator Hours:
              <strong
                class="ui label mr-1"
              >
                {{ checklist.check_out.yacht_generator_hours }} h
              </strong>
            </div>
          </td>
        </tr>
        <tr>
          <td>Signed at</td>
          <td v-if="checklist.check_in">
            {{ checklist.check_in.signed_at | moment('D MMM YYYY HH:mm:ss') }}
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.check_out.signed_at | moment('D MMM YYYY HH:mm:ss') }}
          </td>
        </tr>
        <tr>
          <td>Technician</td>
          <td v-if="checklist.check_in">
            {{ checklist.check_in.technician.name }}
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.check_out.technician.name }}
          </td>
        </tr>
        <tr>
          <td>Guest Name</td>
          <td v-if="checklist.check_in">
            {{ checklist.check_in.guest_name }}
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.check_out.guest_name }}
          </td>
        </tr>
        <tr>
          <td>Guest Email</td>
          <td v-if="checklist.check_in">
            {{ checklist.check_in.guest_email }}
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.check_out.guest_email }}
          </td>
        </tr>
        <tr>
          <td>Guest Telephone</td>
          <td v-if="checklist.check_in">
            {{ checklist.check_in.guest_tel }}
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.check_out.guest_tel }}
          </td>
        </tr>
        <tr>
          <td>Guest Signature</td>
          <td v-if="checklist.check_in">
            <img
              :src="'data:image/png;base64, ' + checklist.check_in.signature"
              style="max-height: 100px"
            >
          </td>
          <td v-if="checklist.check_out">
            <img
              :src="'data:image/png;base64, ' + checklist.check_out.signature"
              style="max-height: 100px"
            >
            <div style="max-width: 300px; font-size: 9px; color: #505050">
              I, the undersigned, agree with the check-out report and confirm that I will not submit any further claims and compensation requests.
            </div>
          </td>
        </tr>
        <tr>
          <td>Notes</td>
          <td v-if="checklist.check_in">
            {{ checklist.check_in.notes ? checklist.check_in.notes : 'n/a' }}
          </td>
          <td v-if="checklist.check_out">
            {{ checklist.check_out.notes ? checklist.check_out.notes : 'n/a' }}
          </td>
        </tr>
      </tbody>
    </table>

    <h5 class="headline mt-6">
      Boat Segments
    </h5>

    <v-row>
      <v-col v-if="checklist.check_in">
        <table class="ui small table">
          <thead>
            <tr>
              <th colspan="2">
                Check In
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(taskType, index) in checklist.service_tasks_types"
              :key="taskType._id"
              :class="{ 'negative': taskType.check_in_status !== 'success' }"
            >
              <td>{{ index + 1 }}. {{ taskType.title }}</td>
              <td
                style="width: 100px"
                class="text-right"
              >
                <div
                  v-if="taskType.check_in_status === 'success'"
                  class="ui small green label"
                >
                  <v-icon
                    size="12px"
                    color="white"
                    class="mr-1"
                  >
                    check
                  </v-icon> OK
                </div>
                <div
                  v-else
                  class="ui small red label"
                >
                  <v-icon
                    size="12px"
                    color="white"
                    class="mr-1"
                  >
                    close
                  </v-icon> Not OK
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col v-if="checklist.check_out">
        <table class="ui small table">
          <thead>
            <tr>
              <th colspan="2">
                Check Out
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(taskType, index) in checklist.service_tasks_types"
              :key="taskType.id"
              :class="{ 'negative': taskType.check_out_status !== 'success' }"
            >
              <td>{{ index + 1 }}. {{ taskType.title }}</td>
              <td
                style="width: 100px"
                class="text-right"
              >
                <div
                  v-if="taskType.check_out_status === 'success'"
                  class="ui small green label"
                >
                  <v-icon
                    size="12px"
                    color="white"
                    class="mr-1"
                  >
                    check
                  </v-icon> OK
                </div>
                <div
                  v-else
                  class="ui small red label"
                >
                  <v-icon
                    size="12px"
                    color="white"
                    class="mr-1"
                  >
                    close
                  </v-icon> Not OK
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>

    <h5 class="headline mt-6">
      Extras
    </h5>

    <v-row>
      <v-col v-if="checklist.check_in">
        <table class="ui small table">
          <tbody v-if="checklist.extras.length === 0">
            <tr>
              <td>No extras</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="task in checklist.extras"
              :key="task.id"
              :class="{ 'negative': task.check_in_status === 'problem' }"
            >
              <td>{{ task.title }}</td>
              <td
                style="width: 100px"
                class="text-right"
              >
                <div
                  v-if="task.check_in_status === 'problem'"
                  class="ui small red label"
                >
                  <v-icon
                    size="12px"
                    color="white"
                    class="mr-1"
                  >
                    close
                  </v-icon>
                  Not OK
                </div>
                <div
                  v-else
                  class="ui small green label"
                >
                  <v-icon
                    size="12px"
                    color="white"
                    class="mr-1"
                  >
                    check
                  </v-icon>
                  OK
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col v-if="checklist.check_out">
        <table class="ui small table">
          <tbody v-if="checklist.extras.length === 0">
            <tr>
              <td>No extras</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="task in checklist.extras"
              :key="task.id"
              :class="{ 'negative': task.check_out_status === 'problem' }"
            >
              <td>{{ task.title }}</td>
              <td
                style="width: 100px"
                class="text-right"
              >
                <div
                  v-if="task.check_out_status === 'problem'"
                  class="ui small red label"
                >
                  <i class="close icon" /> Not OK
                </div>
                <div v-else>
                  <div class="ui small green label">
                    <i class="check icon" /> OK
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>

    <h5 class="headline mt-6">
      Issue Details
    </h5>

    <table class="ui small table">
      <tbody v-if="checklist.service_tasks.length === 0">
        <tr>
          <td>No issues</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr
          v-for="task in checklist.service_tasks"
          :key="task.id"
        >
          <td>
            <router-link
              :to="{ name: 'serviceTasks', query: { 'id': task.id }}"
              target="_blank"
            >
              <strong>{{ task.title }}</strong>
            </router-link>
            <div style="color: #6a6a6a; margin-top: 3px">
              {{ task.description }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'Checklist',
    props: {
      checklist: {
        type: Object,
        default: () => null,
        required: true
      }
    }
  }
</script>

<style>
  .ui.table {
    width: 100%;
    background: #fff;
    margin: 1em 0;
    border: 1px solid rgba(34,36,38,.15);
    box-shadow: none;
    border-radius: .28571429rem;
    text-align: left;
    color: rgba(0,0,0,.87);
    border-collapse: separate;
    border-spacing: 0;
  }
  .ui.definition.table tr td.definition, .ui.definition.table tr td:first-child:not(.ignored) {
    background: rgba(0,0,0,.03);
    font-weight: 700;
    color: rgba(0,0,0,.95);
  }
  .ui.table tr:first-child td {
    border-top: none;
  }
  .ui.table tr td {
    border-top: 1px solid rgba(34,36,38,.1);
  }
  .ui.table td {
    padding: .78571429em .78571429em;
    text-align: inherit;
  }
  .ui.table td, .ui.table th {
    -webkit-transition: background .1s ease,color .1s ease;
    transition: background .1s ease,color .1s ease;
  }
  .ui.table thead {
    box-shadow: none;
  }
  .ui.table thead tr:first-child>th:only-child {
    border-radius: .28571429rem .28571429rem 0 0;
  }
  .ui.table thead tr:first-child>th:last-child {
    border-radius: 0 .28571429rem 0 0;
  }
  .ui.table thead tr:first-child>th:first-child {
    border-radius: .28571429rem 0 0 0;
  }
  .ui.table thead tr>th:first-child {
    border-left: none;
  }
  .ui.table thead th {
    cursor: auto;
    background: #f9fafb;
    text-align: inherit;
    color: rgba(0,0,0,.87);
    padding: .92857143em .78571429em;
    vertical-align: inherit;
    font-style: none;
    font-weight: 700;
    text-transform: none;
    border-bottom: 1px solid rgba(34,36,38,.1);
    border-left: none;
  }
  .ui.table td, .ui.table th {
    -webkit-transition: background .1s ease,color .1s ease;
    transition: background .1s ease,color .1s ease;
  }
  .ui.small.label, .ui.small.labels .label {
    font-size: .78571429rem;
  }
  .ui.green.label, .ui.green.labels .label {
    background-color: #21ba45!important;
    border-color: #21ba45!important;
    color: #fff!important;
  }
  .ui.red.label, .ui.red.labels .label {
    background-color: #db2828!important;
    border-color: #db2828!important;
    color: #fff!important;
  }
  .ui.label:last-child {
    margin-right: 0;
  }
  .ui.label:first-child {
    margin-left: 0;
  }
  .ui.label, .ui.labels .label {
    font-size: .85714286rem;
  }
  .ui.label {
    display: inline-block;
    line-height: 1;
    vertical-align: baseline;
    margin: 0 .14285714em;
    background-color: #e8e8e8;
    background-image: none;
    padding: .5833em .833em;
    color: rgba(0,0,0,.6);
    text-transform: none;
    font-weight: 700;
    border: 0 solid transparent;
    border-radius: .28571429rem;
    -webkit-transition: background .1s ease;
    transition: background .1s ease;
  }
</style>
